import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../Services/servicioURL';

const LoginEmpleados: React.FC = () => {
    const [cveemp, setCveemp] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [error, setError] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [serverStatus, setServerStatus] = useState<'checking' | 'connected' | 'error'>('checking');
    const navigate = useNavigate();

    // Verificar conexión con el servidor
    useEffect(() => {
        const checkServerConnection = async () => {
            try {
                // Intentar hacer una petición simple al servidor
                const response = await fetch(`${BASE_URL}/empleado/login`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        cveemp: 'test',
                        password: 'test',
                    }),
                });

                // Si el servidor responde (aunque sea con error), significa que está conectado
                setServerStatus('connected');
            } catch (err) {
                console.error('Error connecting to server:', err);
                setServerStatus('error');
            }
        };

        // Simular tiempo mínimo de carga para mostrar la animación
        const timer = setTimeout(() => {
            checkServerConnection();
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!cveemp || !password) {
            setError("Clave de empleado y contraseña son obligatorios");
            return;
        }
        
        setIsLoading(true);
        
        try {
            const response = await fetch(`${BASE_URL}/empleado/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    cveemp: cveemp,
                    password: password,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                setError(data.message || 'Credenciales incorrectas');
                setIsLoading(false);
                return;
            }

            localStorage.setItem('authToken2', 'logueado');
            localStorage.setItem('cveEmpleado', data.empleado.cveemp);
            localStorage.setItem('nombreEmpleado', data.empleado.nomemp);

            // Pequeña pausa para mostrar el loading y redirigir a peticiones
            setTimeout(() => {
                navigate('/empinicio');
            }, 1000);
        } catch (err) {
            setError('Ocurrió un error al conectar con el servidor.');
            setIsLoading(false);
            console.error(err);
        }
    };

    const handleInputChange = () => {
        setError('');
    };

    const retryConnection = () => {
        setServerStatus('checking');
        
        // Reintentar conexión después de un breve delay
        setTimeout(async () => {
            try {
                const response = await fetch(`${BASE_URL}/empleado/login`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        cveemp: 'test',
                        password: 'test',
                    }),
                });

                // Si el servidor responde, está conectado
                setTimeout(() => {
                    setServerStatus('connected');
                }, 1500);
            } catch (err) {
                console.error('Error connecting to server:', err);
                setServerStatus('error');
            }
        }, 500);
    };

    // Componente de verificación de conexión
    const ServerCheckAnimation = () => (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: 'url(/dist/img/FondoLogin.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
        }}>
            {/* Overlay para mejorar la visibilidad del contenido */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                zIndex: -1
            }}></div>
            
            <div style={{
                animation: 'pulse 2s ease-in-out infinite',
                marginBottom: '30px'
            }}>
                <img 
                    src="/dist/img/BBT_BLANCO.png" 
                    alt="BBT Logo" 
                    style={{
                        width: '200px',
                        height: 'auto',
                        filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))'
                    }}
                />
            </div>
            
            {serverStatus === 'checking' && (
                <>
                    <div style={{
                        width: '60px',
                        height: '60px',
                        border: '4px solid rgba(255, 255, 255, 0.3)',
                        borderTop: '4px solid #ffffff',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        marginBottom: '20px'
                    }}></div>
                    <p style={{
                        color: '#ffffff',
                        fontSize: '18px',
                        fontWeight: '500',
                        textAlign: 'center',
                        textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
                        margin: 0
                    }}>
                        Conectando con el servidor...
                    </p>
                </>
            )}
            
            {serverStatus === 'error' && (
                <div style={{
                    textAlign: 'center',
                    color: '#ffffff'
                }}>
                    <p style={{
                        fontSize: '20px',
                        fontWeight: '600',
                        textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
                        marginBottom: '20px',
                        color: '#ff6b6b'
                    }}>
                        Error al conectarse con el servidor
                    </p>
                    <Button 
                        label="Reintentar conexión"
                        icon="pi pi-refresh"
                        onClick={retryConnection}
                        style={{
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            border: '2px solid #ffffff',
                            color: '#333',
                            fontWeight: '600',
                            padding: '12px 24px',
                            borderRadius: '8px',
                            fontSize: '16px',
                            transition: 'all 0.3s ease'
                        }}
                        className="retry-button"
                    />
                </div>
            )}
            
            <style>
                {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                    @keyframes pulse {
                        0%, 100% { transform: scale(1); opacity: 1; }
                        50% { transform: scale(1.05); opacity: 0.8; }
                    }
                    @keyframes fadeIn {
                        from { opacity: 0; transform: translateY(20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    .retry-button:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
                        background-color: #ffffff !important;
                    }
                `}
            </style>
        </div>
    );

    // Mostrar pantalla de verificación de servidor si no está conectado
    if (serverStatus !== 'connected') {
        return <ServerCheckAnimation />;
    }

    return (
        <div className="login-page" style={{ 
            minHeight: '100vh', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            backgroundImage: 'url(/dist/img/FondoLogin.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            animation: 'fadeIn 0.8s ease-out',
            position: 'relative'
        }}>
            {/* Overlay para mejorar la legibilidad */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                zIndex: 1
            }}></div>

            <div className="card p-4" style={{ 
                width: '400px', 
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)', 
                borderRadius: '12px',
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                position: 'relative',
                zIndex: 2
            }}>
                {/* Logo de la empresa */}
                <div style={{ 
                    textAlign: 'center', 
                    marginBottom: '30px',
                    paddingTop: '10px'
                }}>
                    <img 
                        src="/dist/img/BBT_AZUL.png" 
                        alt="BBT Logo" 
                        style={{
                            width: '120px',
                            height: 'auto',
                            filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))'
                        }}
                    />
                </div>

                <h3 className="text-center mb-4" style={{ 
                    fontWeight: 'bold',
                    color: '#333',
                    fontSize: '24px'
                }}>Acceso Empleados</h3>

                {error && (
                    <div className="alert alert-danger text-center mb-3" style={{ 
                        fontSize: '14px',
                        backgroundColor: '#f8d7da',
                        border: '1px solid #f5c6cb',
                        borderRadius: '6px',
                        padding: '10px'
                    }}>
                        {error}
                    </div>
                )}

                <form onSubmit={handleLogin} style={{ width: '100%' }}>
                    <div className="form-group mb-3">
                        <label htmlFor="cveemp" style={{ 
                            fontWeight: '500',
                            color: '#555',
                            marginBottom: '8px',
                            display: 'block'
                        }}>Clave de Empleado</label>
                        <InputText 
                            id="cveemp" 
                            className="form-control w-100" 
                            placeholder="Ingrese su clave de empleado" 
                            value={cveemp}
                            onChange={(e) => { setCveemp(e.target.value); handleInputChange(); }}
                            style={{ 
                                height: '45px', 
                                fontSize: '14px',
                                borderRadius: '8px',
                                border: '2px solid #e1e5e9',
                                transition: 'border-color 0.3s ease',
                                backgroundColor: 'rgba(255, 255, 255, 0.9)'
                            }}
                            disabled={isLoading}
                        />
                    </div>

                    <div className="form-group mb-4">
                        <label htmlFor="password" style={{ 
                            fontWeight: '500',
                            color: '#555',
                            marginBottom: '8px',
                            display: 'block'
                        }}>Contraseña</label>
                        <InputText 
                            id="password" 
                            type="password" 
                            className="form-control w-100" 
                            placeholder="Ingrese su contraseña" 
                            value={password}
                            onChange={(e) => { setPassword(e.target.value); handleInputChange(); }}
                            style={{ 
                                height: '45px', 
                                fontSize: '14px',
                                borderRadius: '8px',
                                border: '2px solid #e1e5e9',
                                transition: 'border-color 0.3s ease',
                                backgroundColor: 'rgba(255, 255, 255, 0.9)'
                            }}
                            disabled={isLoading}
                        />
                    </div>

                    <Button 
                        label={isLoading ? "Ingresando..." : "Ingresar"}
                        icon={isLoading ? "pi pi-spin pi-spinner" : "pi pi-sign-in"}
                        className="w-100" 
                        style={{ 
                            height: '45px', 
                            fontSize: '15px', 
                            borderRadius: '8px', 
                            backgroundColor: '#28a745', 
                            border: '1px solid #28a745',
                            color: '#fff',
                            fontWeight: '600',
                            transition: 'all 0.3s ease',
                            opacity: isLoading ? 0.7 : 1
                        }} 
                        type="submit"
                        disabled={isLoading}
                        loading={isLoading}
                    />
                </form>

                <Button 
                    label="Volver al login principal" 
                    icon="pi pi-arrow-left" 
                    className="mt-3 w-100" 
                    style={{ 
                        fontSize: '15px', 
                        height: '45px',
                        border: '2px solid #e1e5e9', 
                        borderRadius: '8px', 
                        backgroundColor: 'rgba(255, 255, 255, 0.9)', 
                        color: '#666',
                        fontWeight: '500',
                        transition: 'all 0.3s ease'
                    }}
                    onClick={() => navigate('/login')}
                    disabled={isLoading}
                />
            </div>

            <style>
                {`
                    @keyframes fadeIn {
                        from { opacity: 0; transform: translateY(20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    
                    .p-inputtext:focus {
                        border-color: #28a745 !important;
                        box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;
                    }
                    
                    .p-button:hover:not(:disabled) {
                        transform: translateY(-1px);
                        box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
                    }
                    
                    .card {
                        transition: transform 0.3s ease;
                    }
                    
                    .card:hover {
                        transform: translateY(-2px);
                    }

                    /* Responsive background */
                    @media (max-width: 768px) {
                        .login-page {
                            background-attachment: scroll !important;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default LoginEmpleados;